import { render } from "./Incassi.vue?vue&type=template&id=6bf6af71"
import script from "./Incassi.vue?vue&type=script&lang=js"
export * from "./Incassi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__